<template>
  <card>
     <template slot="header">
        <h3 class="card-title">ENCODE NOTICE TO EXPLAIN</h3>
     </template>
     <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
           <li class="breadcrumb-item">
              <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
           </li>
           <li class="breadcrumb-item">
              <router-link to="/hr/nterequest">NTE Tracker</router-link>
           </li>
           <li class="breadcrumb-item active">Encode NTE Manually</li>
        </ol>
     </nav>
     <hr style="margin-top:-10px" />
     <form @submit.prevent="formSubmit">
        <div class="row">
           <div class="col-md-12">
              <label>Select Employee</label>
              <select class="form-control" v-model="employee_id"  v-bind:class="{ 'is-invalid': error_handler && error_handler.employee_id}">
                 <option value="">-- Select One --</option>
                 <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name | capitalize}}</option>
              </select>
              <span v-if="error_handler.employee_id" class="invalid-feedback">{{ error_handler.employee_id[0] }}</span>
           </div>
        </div>
        <br/>
       <i class="fa fa-warning"></i> <b>Note</b>: This module you can encode your previous record manually without the use of Employee Self Service or <b>ESS System</b>.<br/><br/>
        <font color="#4285f4" class="title-section"><i class="fa fa-check"></i> Corrective Action</font><font size="2" color="red" class="float-right">Note: (*) All Fields Are Required</font>
        <div class="border-box-nte">
           <div class="row">
              <div class="col-md-4 ">
                 <label>Corrective Action To be Taken</label>
                 <select class="form-control" @change="dismissal" v-model="corrective" v-bind:class="{ 'is-invalid': error_handler && error_handler.action_to_be_taken}">
                    <option value="">--Select One --</option>
                    <option value="nte">Notice To Explain</option>
                    <option value="suspension">Suspension</option>
                    <option value="dismissal">Dismissal</option>
                 </select>
                 <span v-if="error_handler.action_to_be_taken" class="invalid-feedback">{{ error_handler.action_to_be_taken[0] }}</span>
              </div>
              <div class="col-md-4">
                 <div class="form-group">
                    <label>Date Request</label>
                    <input type="date" v-model="date_request" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_request}">
                    <span v-if="error_handler.date_request" class="invalid-feedback">{{ error_handler.date_request[0] }}</span>
                 </div>
              </div>
              <div class="col-md-4">
                 <div class="form-group">
                    <label>Date Incident</label>
                    <input type="date" v-model="date_incident" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_incident}">
                    <span v-if="error_handler.date_incident" class="invalid-feedback">{{ error_handler.date_incident[0] }}</span>
                 </div>
              </div>
              <div v-if="corrective == 'nte'">
                 <div class="col-md-12 ">
                    <font color="red">Select one for your employee action</font>
                    <br/>
                    <input type="radio" v-model="action_to_be_taken" value="VW - Verbal Warning"> VW - Verbal Warning
                    <input type="radio" v-model="action_to_be_taken" value="NTE 1"> NTE 1
                    <input type="radio" v-model="action_to_be_taken" value="NTE 2"> NTE 2
                    <input type="radio" v-model="action_to_be_taken" value="NTE 3"> NTE 3
                 </div>
              </div>
              <div v-if="corrective == 'suspension'">
                 <div class="col-md-12 ">
                    <font color="red">Select one for your employee action</font>
                    <br/>
                    <input type="radio" v-model="action_to_be_taken" value="3 Days Suspension"> 3 Days Suspension
                    <input type="radio" v-model="action_to_be_taken" value="10 Days Suspension"> 10 Days Suspension
                 </div>
              </div>
           </div>
        </div>
        <br/>
        <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Infraction Details</font><font size="2" color="red" class="float-right">Note: (*) All Fields Are Required</font>
        <div class="border-box-nte">
           <div class="row">
              <div class="col-md-6">
                 <label>Type of Infraction :</label>
                 <select v-model="type_of_infraction" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.type_of_infraction}">
                     <option value="">--Select Infraction Type --</option>
                     <option>i. Attendance and Punctuality</option>
                     <option>ii. Time Keeping Infraction</option>
                     <option>iii. Office Protocol and Decorum</option>
                     <option>iv. Neglect of Duty</option>
                     <option>v. Fraud and Similar Acts Prejudicial to Company Interest</option>
                     <option>vi. Health and Sanitation</option>
                     <option>vii. Company Facilities and Property</option>
                     <option>viii. Insubordination</option>
                     <option>ix. Confidentiality of Work and Information</option>
                     <option>x. The Use of Workstations, Computer, Computer Programs, etc.</option>
                     <option>xi. People Management</option>
                     <option>xii. Policy on Call Handling</option>
                     <option>xiii. Sexual Harrassment</option>
                     <option>xiv. Prohibited Drugs and Paraphernalia</option>
                 </select> 
                 <span v-if="error_handler.type_of_infraction" class="invalid-feedback">{{ error_handler.type_of_infraction[0] }}</span>  
              </div>
              <div class="col-md-6">
                 <label>Details of Infraction</label>
                 <textarea class="form-control" v-model="details_of_infraction" rows="6" v-bind:class="{ 'is-invalid': error_handler && error_handler.details_of_infraction}"></textarea>
                 <span v-if="error_handler.details_of_infraction" class="invalid-feedback">{{ error_handler.details_of_infraction[0] }}</span>
              </div>
           </div>
        </div>
        <br/>
        <br/>
        <b><u>ATTACHMENT FILE</u></b>
         <br/><br/>
         <!-- MULTIPLE FILE UPLOAD HERE -->
         <div class="upload-btn-wrapper ">
            <label for="nteFiles" class="custom-file-upload"> <i class="fa fa-upload"></i>Attach Files</label>
            <input type="file" ref="files" id="nteFiles" multiple="multiple" accept=".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif" @change="handleNteFilesUpload"/> 
            <span v-for="item in error_handler.files">
               <li class="invalid-feedback d-block">{{item}}</li>
            </span>
            <div v-for="(file,key) in nteFiles" :key="key" class="mb-2 mt-2">
                  <slot v-if="file.type == 'application/pdf'">
                        <i class="fa fa-file-pdf-o fa-2x"></i>
                  </slot>
                  <slot v-else-if="file.type=='application/msword'">
                        <i class="fa fa-file-word-o fa-2x"></i>
                  </slot> 
                  <slot v-else-if="file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                        <i class="fa fa-file-word-o fa-2x"></i>
                  </slot>
                  <slot v-else-if="file.type=='image/jpeg'">
                        <i class="fa fa-file-image-o fa-2x"></i>
                     </slot> 
                  <slot v-else-if="file.type=='image/png'">
                     <i class="fa fa-file-image-o fa-2x"></i>
                  </slot>   
                        &nbsp;&nbsp; {{file.name}} - {{file.size}}
                  <span @click="removenteFilesUpload(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
            </div>                               
         </div>
         <!-- END MULTIPLE FILE UPLOAD HERE --> 
        <br/><br/>
        <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Details of Occurence</font><font size="2" color="red" class="float-right">Note: (*) This Fields Are Optional</font>
        <div class="border-box-nte">
           <div v-for="(res ,index) in details_of_occurence">
              <div class="row">
                 <div class="col-md-3">
                    <div class="form-group">
                       <label>Date of Occurence:</label>
                       <input type="date" v-model="res.date" class="form-control">
                    </div>
                 </div>
                 <div class="col-md-8">
                    <div class="form-group">
                       <label>Item Description:</label>
                       <input type="text" v-model="res.details" class="form-control">
                    </div>
                 </div>
                  <div class="col-md-1 mt-4"> 
                        <button @click.stop.prevent="add_form" class="btn btn-sm btn-primary"><i class="fa fa-plus"></i></button>
                        <button @click.stop.prevent="delete_form(index)" class="btn btn-sm btn-primary"><i class="fa fa-minus"></i></button>
                  </div>
              </div>
           </div>
        </div>
        <br/>
        <font color="#4285f4" class="title-section"><i class="fa fa-user"></i> Employees Commitment</font><font size="2" color="red" class="float-right">Note: (*) All Fields Are Required</font>
        <div class="border-box-nte">
           <div class="row"> 
               <div class="col-md-6">
                  <div class="form-group">
                      <label>Plan for Improvement:</label>
                       <textarea rows="8" v-model="plan_for_improvement" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.plan_for_improvement}"></textarea>
                       <span v-if="error_handler.plan_for_improvement" class="invalid-feedback">{{ error_handler.plan_for_improvement[0] }}</span>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="form-group">
                      <label>Employee's Commitment :</label>
                      <textarea rows="8" v-model="employees_commitment" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.employees_commitment}"></textarea>
                      <span v-if="error_handler.employees_commitment" class="invalid-feedback">{{ error_handler.employees_commitment[0] }}</span>
                  </div>
                  </div>
              </div>     
        </div> <br/>
        <font color="#4285f4" class="title-section"><i class="fa fa-balance-scale"></i>&nbsp;&nbsp;Notice for Decision</font><font size="2" color="red" class="float-right">Note: (*) All Fields Are Required</font>
        <div class="border-box-nte">
            <div class="row">
                <div class="col-md-6">
                   <div class="form-group">
                       <label>HR/Admin Decision for Employee NTE:</label>
                        <textarea rows="8" v-model="hr_notice_for_decision" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.hr_notice_for_decision}"></textarea>
                        <span v-if="error_handler.hr_notice_for_decision" class="invalid-feedback">{{ error_handler.hr_notice_for_decision[0] }}</span>
                  </div>
               </div>
            </div>
        </div>
        <div class="form-group">
           <div class="float-right">
              <br/>
              <br/>
              <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button>
              <br/>
              <br/>
              <br/>
              <br/>
           </div>
        </div>
        <br/>
        <br/>
     </form>
     <p>HR FORM NO. 0005</p>
  </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
components: {
Card,
},

data() {
return {
//items
employees: [],
// error
error_handler: [],
//input
employee_id: '',
details_of_occurence: [{
  date: '',
  detail: ''
}],
nteFiles: [],
files: {},
date_incident: '',
date_request: '',
date_incident: '',
infraction: '',
action_to_be_taken: '',
type_of_infraction: '',
details_of_infraction: '',
//employee side
plan_for_improvement:'',
employees_commitment:'',
// events, 
hr_notice_for_decision:'',
corrective: ''
}
},

mounted: function () {
this.get_employees()
},

methods: {

dismissal() {
if (this.corrective == 'dismissal') {
  this.action_to_be_taken = 'Dismissal'
}
},
add_form: function () {
this.details_of_occurence.push({
  date: '',
  detail: ''
})
},

delete_form: function (index) {
this.details_of_occurence.splice(index, 1);
if (index === 0)
  this.add_form()
},

get_employees() {
axios.get('api/active/employee')
  .then(response => {
    this.employees = response.data;
  })
  .catch(error => {
    console.log(error.response)
  });
},

//FILE UPLOAD
handleNteFilesUpload() {
  let uploadedNTEFiles = event.target.files;
  if(!uploadedNTEFiles.length)
      return
  for (let i = 0; i < uploadedNTEFiles.length; i++){
          this.nteFiles.push( uploadedNTEFiles[i])
  }
  console.log('response => ', uploadedNTEFiles)
},

removenteFilesUpload(key){
    this.nteFiles.splice(key, 1)
},

resetData(){
  this.data = new FormData()
  this.files = []
  this.infraction_item = []
  this.error_handler = [],
  this.employee_id = ''
  this.date_request = ''
  this.requested_by = ''
  this.date_incident = ''
  this.details_occurence = ''
  this.type_of_infraction = ''
  this.action_to_be_taken = ''
  this.details_of_infraction = ''
 this.plan_for_improvement = ''
 this.employees_commitment = ''
 this.hr_notice_for_decision = ''
  this.details_of_occurence = [{
       'date':'',
       'detail':''
   }]
},

formSubmit(e) {
e.preventDefault();
this.$swal({
    title: 'Are you sure?',
    text: 'Do you want to submit this request',
    type: 'warning',
    showCancelButton: true,
    showCloseButton: false,
  })
  .then((isConfirm) => {
    if (isConfirm === true) {
      //Form data a files to upload
      let formData = new FormData()
      for (var i = 0; i < this.nteFiles.length; i++) {
            let file = this.nteFiles[i];
            formData.append('files[' + i + ']', file);
      }
      //Additional POST Request
      formData.append('employee_id', this.employee_id)
      formData.append('requested_by', this.requested_by)
      formData.append('date_request', this.date_request)
      formData.append('date_incident', this.date_incident)
      formData.append('details_of_infraction', this.details_of_infraction)
      formData.append('details_occurence', JSON.stringify(this.details_of_occurence))
      formData.append('type_of_infraction', this.type_of_infraction)
      formData.append('action_to_be_taken', this.action_to_be_taken)
      formData.append('plan_for_improvement', this.plan_for_improvement)
      formData.append('employees_commitment', this.employees_commitment)
      formData.append('hr_notice_for_decision', this.hr_notice_for_decision)
      formData.append('details_of_infraction', this.details_of_infraction)
      axios.post('api/ntestoremanually/add', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: "Bearer " + localStorage.getItem("token")
         }
        })
        .then(resp => {
          this.$swal('Success', 'You successfully submitted this request.', 'success')
          this.$router.push({
            name: 'nte-request'
          })
        })
        .catch(error => {
          if (error.response.status == 422) {
            this.error_handler = error.response.data.errors
          }
          console.log('response => ', error.response);
        });
    }
  });
},
},
computed: {


},

}
</script>
<style>
  input[type="file"] {
        display: none; /* Hide default file input */
    }
    .custom-file-upload {
        display: inline-block;
        background-color: #007bff;
        color: white;
        padding: 10px 15px;
        border-radius: 5px;
        cursor: pointer;
        font-weight: bold;
    }

    .custom-file-upload:hover {
        background-color: #0056b3;
    }
</style>






// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-nte-manual-input.vue